export const formatCardNumber = (value) =>
  value.replace(/\D/g, '').replace(/(.{4})/g, '$1 ').trim();

export const detectCardType = (number) => {
  const cleaned = number.replace(/\s/g, '');
  if (/^4/.test(cleaned)) return 'visa';                 // Visa
  if (/^5[1-5]/.test(cleaned)) return 'mastercard';      // MasterCard
  if (/^60/.test(cleaned)) return 'rupay';               // RuPay
  if (/^35/.test(cleaned)) return 'jcb';                 // JCB
  if  (/^6(?:011|5)/.test(cleaned)) return 'discover';    // Discover
  if (/^36|^38|^30[0-5]/.test(cleaned)) return 'diners-club'; // Diners Club
};

export const isValidLuhn = (number) => {
  const digits = number.replace(/\D/g, '').split('').reverse().map(Number);
  return (
    digits.reduce((acc, digit, i) => {
      if (i % 2) {
        const doubled = digit * 2;
        return acc + (doubled > 9 ? doubled - 9 : doubled);
      }
      return acc + digit;
    }, 0) % 10 === 0
  );
};

export const formatExpiry = (value) => {
  const cleaned = value.replace(/\D/g, '').slice(0, 4); // only digits, max 4
  if (cleaned.length <= 2) return cleaned;
  return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
};

export const validateField = (field, value) => {
  if (field.required) {
    if (field.type === 'checkbox' && !value) {
      return field.validation?.mustBeChecked?.errorMessage || 'Required';
    }
    if (field.type !== 'checkbox' && !value.trim()) {
      return 'Required';
    }
  }

  if (field.validation?.minLength?.value && value.length < field.validation.minLength.value) {
    return field.validation.minLength.errorMessage;
  }

  if (field.validation?.maxLength?.value && value.length > field.validation.maxLength.value) {
    return field.validation.maxLength.errorMessage;
  }

  if (field.validation?.pattern?.value && value) {
    const regex = new RegExp(field.validation.pattern.value);
    if (!regex.test(value)) {
      return field.validation.pattern.errorMessage;
    }
  }

  return '';
};
